//import React, { useEffect, useState } from 'react';
//import { useSelector } from "react-redux";
//import useAxiosInstance from '../../../services/useAxiosInstance';

//const DashboardServiceRequest = () => {
//  const axiosInstance = useAxiosInstance();

//  const [serviceRequests, setServiceRequests] = useState([]);
//  const [statusList, setStatusList] = useState({});
//  const [serviceTypes, setServiceTypes] = useState({});
//  const userId = useSelector((state) => state.auth.userId);
//  const clinetId = useSelector((state) => state.auth.clientId);
//  const communityId = useSelector((state) => state.auth.communityId);
//  const [loading, setLoading] = useState(false);

//  const communityIds = useSelector((state) => state.auth.communityId);
//  console.log(communityIds, clinetId);
//  const communityIdget = communityIds;
//  const [serviceRequestStatusIds, setserviceRequestStatusIds] = useState(0);
//  const fetchServiceTypes = async () => {
//    try {
//      const response = await axiosInstance.get(`/api/public/servicetype/getAll`);
//      const typesData = response.data;
//      const typesMap = {};
//      typesData.forEach(type => {
//        typesMap[type.id] = type.name;
//      });
//      setServiceTypes(typesMap);
//    } catch (error) {
//      console.error('Error fetching service types:', error);
//    }
//  };

//  const fetchServiceRequests = async () => {
//    setLoading(true);
//    try {
//      const response = await axiosInstance.get(`/api/public/servicerequest/CommunityIdAndCreatedById`,
//        {
//          params: {
//            requestedClientId: clinetId,
//            communityId: communityIdget,
//          }
//        }
//      );
//      console.log('dsa');
//      setServiceRequests(response.data);

//      console.log("Service Requests, with dates:", response.data);
//    } catch (error) {
//      console.error('Error fetching service requests:', error);
//    } finally {
//      setLoading(false);
//    }
//  };

//  const fetchStatuses = async () => {
//    setLoading(true);
//    try {
//      const response = await axiosInstance.get(`/api/serviceRequestStatus/getAll`);
//      const statusData = response.data;
//      const statusMap = {};
//      statusData.forEach(status => {
//        statusMap[status.serviceRequestStatusId] = status.serviceRequestStatus;
//      });
//      setStatusList(statusMap);
//    } catch (error) {
//      console.error('Error fetching statuses:', error);
//    } finally {
//      setLoading(false);
//    }
//  };

//  useEffect(() => {
//    fetchServiceRequests();
//    fetchStatuses();
//    fetchServiceTypes();
//  }, []);

//  const formattedDate = (date) => {
//    return new Date(date).toLocaleDateString();
//  };

//  const filteredServiceRequests = serviceRequests
//    .sort((a, b) => new Date(b.requiredDate) - new Date(a.requiredDate))
//    .slice(0, 3);

//  return (
//    <div className="w-full">
//      <div className="w-full">
//        <div className="px-4 py-4 border-b-2 border-gray-300">
//          <h2>Service Request</h2>
//        </div>
//        <div>
//          <div className="overflow-x-auto">
//            <table className="w-full border-collapse bg-white">
//              <thead className="bg-fdb272 text-white">
//                <tr>
//                  <th className="text-sm p-2.5 text-left border-b-2 border-gray-300">Service Name</th>
//                  <th className="text-sm p-2.5 text-left border-b-2 border-gray-300">Vendor Access Code</th>
//                  <th className="text-sm p-2.5 text-left border-b-2 border-gray-300">Required Date</th>
//                  <th className="text-sm p-2.5 text-left border-b-2 border-gray-300">Active Status</th>
//                </tr>
//              </thead>
//              <tbody>
//                {filteredServiceRequests.length === 0 ? (
//                  <tr>
//                    <td colSpan="4" className="text-center">No Data Found</td>
//                  </tr>
//                ) : (
//                  filteredServiceRequests.map((item) => (
//                    <tr key={item.serviceRequestId} className="even:bg-gray-100">
//                      <td className="text-xs p-2.5 text-left">{item.serviceTypeName}</td>
//                      <td className="text-xs p-2.5 text-center">{item.vendorAccessCode}</td>
//                      <td className="text-xs p-2.5 text-right">{formattedDate(item.requiredDate)}</td>
//                      <td className="text-xs p-2.5 text-center">{item.serviceRequestStatusName}</td>
//                    </tr>
//                  ))
//                )}
//              </tbody>
//            </table>
//          </div>
//        </div>
//      </div>
//    </div>
//  );
//};

//export default DashboardServiceRequest;

import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import useAxiosInstance from '../../../services/useAxiosInstance';
import { Wrench, AlertCircle, Clock, CheckCircle, XCircle } from 'lucide-react';

const DashboardServiceRequest = ({ startDate, endDate }) => {
    const axiosInstance = useAxiosInstance();
    const [serviceRequests, setServiceRequests] = useState([]);
    const [statusList, setStatusList] = useState({});
    const [serviceTypes, setServiceTypes] = useState({});
    const [loading, setLoading] = useState(false);
    const [communities, setCommunities] = useState({});

    const userId = useSelector((state) => state.auth.userId);
    const clientId = useSelector((state) => state.auth.clientId);
    const communityId = useSelector((state) => state.auth.communityId);
    const roleId = useSelector((state) => state.auth.roleId);

    // Role-based parameter configuration
    const getApiParameters = () => {
        let communityIdParam, clientIdParam, endpoint;

        switch (roleId) {
            case 1000: // Superadmin - All communities, all service requests
                communityIdParam = 0;
                clientIdParam = 0;
                endpoint = `/api/public/servicerequest/admin/getAllServiceRequests`;
                break;
            case 1003: // User - Personal service requests only
                communityIdParam = communityId;
                clientIdParam = clientId;
                endpoint = `/api/public/servicerequest/CommunityIdAndCreatedById`;
                break;
            default: // Other roles shouldn't see this component
                return null;
        }

        return { communityIdParam, clientIdParam, endpoint };
    };

    // Check if user should have access to this component
    const hasAccess = () => {
        return roleId === 1000 || roleId === 1003;
    };

    const fetchServiceTypes = async () => {
        try {
            const response = await axiosInstance.get(`/api/public/servicetype/getAll`);
            const typesData = response.data;
            const typesMap = {};
            typesData.forEach(type => {
                typesMap[type.id] = type.name;
            });
            setServiceTypes(typesMap);
        } catch (error) {
            console.error('Error fetching service types:', error);

            // Fallback service types
            setServiceTypes({
                1: 'Plumbing',
                2: 'Electrical',
                3: 'HVAC',
                4: 'Landscaping',
                5: 'General Maintenance',
                6: 'Pest Control',
                7: 'Cleaning Services'
            });
        }
    };

    const fetchCommunities = async () => {
        if (roleId === 1000) {
            try {
                const response = await axiosInstance.get(`/api/public/community/getAll`);
                const communitiesData = response.data;
                const communitiesMap = {};
                communitiesData.forEach(community => {
                    communitiesMap[community.communityId] = community.name;
                });
                setCommunities(communitiesMap);
            } catch (error) {
                console.error('Error fetching communities:', error);

                // Fallback communities
                setCommunities({
                    101: 'Oak Hills Community',
                    102: 'Pine Valley Estates',
                    103: 'Maple Gardens',
                    104: 'Cedar Ridge HOA',
                    105: 'Willow Creek'
                });
            }
        }
    };

    const fetchServiceRequests = async () => {
        const apiConfig = getApiParameters();
        if (!apiConfig) return;

        setLoading(true);
        try {
            const { communityIdParam, clientIdParam, endpoint } = apiConfig;

            const response = await axiosInstance.get(endpoint, {
                params: {
                    requestedClientId: clientIdParam,
                    communityId: communityIdParam,
                    ...(startDate && endDate && { startDate, endDate })
                }
            });

            console.log('Service requests data:', response.data);

            // Handle different response structures
            if (Array.isArray(response.data)) {
                setServiceRequests(response.data);
            } else if (response.data.serviceRequests) {
                setServiceRequests(response.data.serviceRequests);
            } else {
                setServiceRequests([]);
            }
        } catch (error) {
            console.error('Error fetching service requests:', error);

            // Fallback data based on role
            setFallbackData();
        } finally {
            setLoading(false);
        }
    };

    // Fallback data based on role
    const setFallbackData = () => {
        const currentDate = new Date();
        const getRandomDate = (daysAgo) => {
            const date = new Date(currentDate);
            date.setDate(currentDate.getDate() - daysAgo);
            return date.toISOString();
        };

        if (roleId === 1000) {
            // Superadmin - Multiple service requests across communities
            setServiceRequests([
                {
                    serviceRequestId: 1,
                    serviceTypeName: 'Plumbing Repair',
                    vendorAccessCode: 'PLB-2024-001',
                    requiredDate: getRandomDate(1),
                    serviceRequestStatusName: 'In Progress',
                    clientName: 'John Smith',
                    communityId: 101,
                    description: 'Kitchen sink leak repair'
                },
                {
                    serviceRequestId: 2,
                    serviceTypeName: 'HVAC Maintenance',
                    vendorAccessCode: 'HVAC-2024-002',
                    requiredDate: getRandomDate(2),
                    serviceRequestStatusName: 'Vendor Assigned',
                    clientName: 'Sarah Johnson',
                    communityId: 102,
                    description: 'Annual AC unit servicing'
                },
                {
                    serviceRequestId: 3,
                    serviceTypeName: 'Electrical Work',
                    vendorAccessCode: 'ELC-2024-003',
                    requiredDate: getRandomDate(3),
                    serviceRequestStatusName: 'Completed',
                    clientName: 'Mike Davis',
                    communityId: 103,
                    description: 'Outlet installation'
                },
                {
                    serviceRequestId: 4,
                    serviceTypeName: 'Landscaping',
                    vendorAccessCode: 'LSC-2024-004',
                    requiredDate: getRandomDate(5),
                    serviceRequestStatusName: 'Pending',
                    clientName: 'Linda Wilson',
                    communityId: 101,
                    description: 'Tree trimming service'
                },
                {
                    serviceRequestId: 5,
                    serviceTypeName: 'General Maintenance',
                    vendorAccessCode: 'GEN-2024-005',
                    requiredDate: getRandomDate(7),
                    serviceRequestStatusName: 'Cancelled',
                    clientName: 'Robert Brown',
                    communityId: 104,
                    description: 'Fence repair'
                }
            ]);
        } else if (roleId === 1003) {
            // User - Personal service requests only
            setServiceRequests([
                {
                    serviceRequestId: 1,
                    serviceTypeName: 'Plumbing Repair',
                    vendorAccessCode: 'PLB-2024-001',
                    requiredDate: getRandomDate(2),
                    serviceRequestStatusName: 'In Progress',
                    description: 'Kitchen sink leak repair'
                },
                {
                    serviceRequestId: 2,
                    serviceTypeName: 'HVAC Maintenance',
                    vendorAccessCode: 'HVAC-2024-002',
                    requiredDate: getRandomDate(5),
                    serviceRequestStatusName: 'Completed',
                    description: 'Annual AC unit servicing'
                },
                {
                    serviceRequestId: 3,
                    serviceTypeName: 'Electrical Work',
                    vendorAccessCode: 'ELC-2024-003',
                    requiredDate: getRandomDate(10),
                    serviceRequestStatusName: 'Vendor Assigned',
                    description: 'Outlet installation in garage'
                }
            ]);
        }
    };

    const fetchStatuses = async () => {
        try {
            const response = await axiosInstance.get(`/api/serviceRequestStatus/getAll`);
            const statusData = response.data;
            const statusMap = {};
            statusData.forEach(status => {
                statusMap[status.serviceRequestStatusId] = status.serviceRequestStatus;
            });
            setStatusList(statusMap);
        } catch (error) {
            console.error('Error fetching statuses:', error);

            // Fallback statuses
            setStatusList({
                1: 'Pending',
                2: 'Vendor Assigned',
                3: 'In Progress',
                4: 'Completed',
                5: 'Cancelled'
            });
        }
    };

    useEffect(() => {
        if (hasAccess()) {
            fetchServiceRequests();
            fetchStatuses();
            fetchServiceTypes();
            fetchCommunities();
        }
    }, [roleId, clientId, communityId, startDate, endDate]);

    // Don't render for unauthorized roles
    if (!hasAccess()) {
        return (
            <div className="w-full p-8 text-center">
                <AlertCircle size={48} className="mx-auto text-gray-400 mb-4" />
                <h3 className="text-lg font-medium text-gray-600 mb-2">Access Restricted</h3>
                <p className="text-gray-500">This component is only available for users and system administrators.</p>
            </div>
        );
    }

    const formattedDate = (date) => {
        return new Date(date).toLocaleDateString();
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'Completed':
                return <CheckCircle size={16} className="text-green-500" />;
            case 'In Progress':
                return <Clock size={16} className="text-blue-500" />;
            case 'Cancelled':
                return <XCircle size={16} className="text-red-500" />;
            case 'Vendor Assigned':
                return <Wrench size={16} className="text-yellow-500" />;
            default:
                return <AlertCircle size={16} className="text-gray-500" />;
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case 'Completed':
                return 'bg-green-100 text-green-800';
            case 'In Progress':
                return 'bg-blue-100 text-blue-800';
            case 'Cancelled':
                return 'bg-red-100 text-red-800';
            case 'Vendor Assigned':
                return 'bg-yellow-100 text-yellow-800';
            case 'Pending':
                return 'bg-gray-100 text-gray-800';
            default:
                return 'bg-gray-100 text-gray-700';
        }
    };

    // Role-based display configuration
    const getDisplayConfig = () => {
        if (roleId === 1000) {
            return {
                title: "Service Requests - System Overview",
                description: "Recent service requests across all communities",
                showCommunity: true,
                showClientName: true,
                maxItems: 10
            };
        } else if (roleId === 1003) {
            return {
                title: "My Service Requests",
                description: "Your recent service requests",
                showCommunity: false,
                showClientName: false,
                maxItems: 5
            };
        }
        return {};
    };

    const displayConfig = getDisplayConfig();
    const displayData = serviceRequests
        .sort((a, b) => new Date(b.requiredDate) - new Date(a.requiredDate))
        .slice(0, displayConfig.maxItems);

    return (
        <div className="w-full">
            <div className="w-full">
                <div className="px-4 py-4 border-b-2 border-gray-300">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-lg font-semibold text-gray-800">{displayConfig.title}</h2>
                            <p className="text-sm text-gray-500">{displayConfig.description}</p>
                        </div>
                        {loading && (
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                        )}
                    </div>
                </div>

                <div>
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse bg-white">
                            <thead className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
                                <tr>
                                    {displayConfig.showCommunity && (
                                        <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Community</th>
                                    )}
                                    {displayConfig.showClientName && (
                                        <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Client</th>
                                    )}
                                    <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Service Name</th>
                                    <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Access Code</th>
                                    <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Required Date</th>
                                    <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Status</th>
                                    {roleId === 1000 && (
                                        <th className="text-sm p-2.5 text-left border-b-2 border-blue-300">Description</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {displayData.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={
                                                displayConfig.showCommunity && displayConfig.showClientName ? 7 :
                                                    displayConfig.showCommunity || displayConfig.showClientName ? 6 : 5
                                            }
                                            className="text-center py-8"
                                        >
                                            <div className="flex flex-col items-center justify-center text-gray-500">
                                                <Wrench size={32} className="mb-2" />
                                                <p className="font-medium">No Service Requests Found</p>
                                                <p className="text-sm text-gray-400 mt-1">
                                                    {roleId === 1000 ? "No requests in the system" : "You haven't submitted any service requests yet"}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    displayData.map((item) => (
                                        <tr key={item.serviceRequestId} className="even:bg-gray-50 hover:bg-blue-50 transition-colors">
                                            {displayConfig.showCommunity && (
                                                <td className="text-xs p-2.5 text-left font-medium">
                                                    {communities[item.communityId] || `Community ${item.communityId}`}
                                                </td>
                                            )}
                                            {displayConfig.showClientName && (
                                                <td className="text-xs p-2.5 text-left">
                                                    {item.clientName || 'N/A'}
                                                </td>
                                            )}
                                            <td className="text-xs p-2.5 text-left font-medium">
                                                {item.serviceTypeName}
                                            </td>
                                            <td className="text-xs p-2.5 text-center font-mono bg-gray-100">
                                                {item.vendorAccessCode}
                                            </td>
                                            <td className="text-xs p-2.5 text-right">
                                                {formattedDate(item.requiredDate)}
                                            </td>
                                            <td className="text-xs p-2.5 text-center">
                                                <div className="flex items-center justify-center gap-1">
                                                    {getStatusIcon(item.serviceRequestStatusName)}
                                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusClass(item.serviceRequestStatusName)}`}>
                                                        {item.serviceRequestStatusName}
                                                    </span>
                                                </div>
                                            </td>
                                            {roleId === 1000 && (
                                                <td className="text-xs p-2.5 text-left max-w-xs truncate">
                                                    {item.description || 'No description'}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Summary section for superadmin */}
                {roleId === 1000 && displayData.length > 0 && (
                    <div className="p-4 border-t border-gray-200 bg-gray-50">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                            <div>
                                <p className="text-sm text-gray-600">Total Requests</p>
                                <p className="text-xl font-bold text-gray-800">{serviceRequests.length}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">In Progress</p>
                                <p className="text-xl font-bold text-blue-600">
                                    {serviceRequests.filter(r => r.serviceRequestStatusName === 'In Progress').length}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Completed</p>
                                <p className="text-xl font-bold text-green-600">
                                    {serviceRequests.filter(r => r.serviceRequestStatusName === 'Completed').length}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Pending</p>
                                <p className="text-xl font-bold text-gray-600">
                                    {serviceRequests.filter(r => r.serviceRequestStatusName === 'Pending').length}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardServiceRequest;